import { render, staticRenderFns } from "./PlantUsed.vue?vue&type=template&id=18ad54be&scoped=true&"
import script from "./PlantUsed.vue?vue&type=script&lang=js&"
export * from "./PlantUsed.vue?vue&type=script&lang=js&"
import style0 from "./PlantUsed.vue?vue&type=style&index=0&id=18ad54be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ad54be",
  null
  
)

export default component.exports